import { Button } from '../../../components/UI'

export default function MCRepeaterGrid({ title, columns, rows, onChange }) {
  const addRow = () => onChange([...(rows || []), Object.fromEntries(columns.map((c) => [c.key, c.defaultValue ?? '']))])
  const remove = (idx) => onChange(rows.filter((_, i) => i !== idx))
  const update = (idx, key, value) => onChange(rows.map((row, i) => (i === idx ? { ...row, [key]: value } : row)))

  return (
    <div className="rounded-lg border border-gray-200 p-3 space-y-3">
      <div className="flex items-center justify-between">
        <h3 className="text-sm font-semibold text-gray-900">{title}</h3>
        <Button size="sm" type="button" onClick={addRow}>Agregar fila</Button>
      </div>
      <div className="space-y-2">
        {(rows || []).map((row, idx) => (
          <div key={idx} className="grid grid-cols-12 gap-2">
            {columns.map((col) => (
              <input
                key={col.key}
                className={`col-span-${col.span || 3} rounded-lg border px-2 py-2 text-sm`}
                placeholder={col.label}
                value={row[col.key] ?? ''}
                type={col.type || 'text'}
                step={col.step}
                onChange={(e) => update(idx, col.key, col.type === 'number' ? Number(e.target.value) : e.target.value)}
              />
            ))}
            <button className="col-span-1 rounded-lg border text-red-600 text-sm" type="button" onClick={() => remove(idx)}>✕</button>
          </div>
        ))}
      </div>
    </div>
  )
}
